import { CATEGORY_COLORS, PRIORITY_COLORS } from "@/lib/api";

const darkCats = ["Urgent"];

export const CategoryBadge = ({ category, testid }) => (
  <span
    data-testid={testid}
    className="inline-flex items-center rounded-full px-3 py-1 text-xs font-bold border-2 border-black"
    style={{ backgroundColor: CATEGORY_COLORS[category] || "#F3F4F6", color: darkCats.includes(category) ? "#fff" : "#0A0A0A" }}
  >
    {category}
  </span>
);

export const PriorityBadge = ({ priority, testid }) => (
  <span
    data-testid={testid}
    className="inline-flex items-center rounded-full px-3 py-1 text-xs font-bold border-2 border-black"
    style={{ backgroundColor: PRIORITY_COLORS[priority] || "#9CA3AF", color: "#fff" }}
  >
    {priority}
  </span>
);

const STATUS_STYLE = {
  pending: { bg: "#fff", label: "Pending" },
  not_started: { bg: "#fff", label: "Not Started" },
  in_progress: { bg: "#FEF9C3", label: "In Progress" },
  waiting_for_parts: { bg: "#FFEDD5", label: "Waiting for Parts" },
  waiting_for_employee: { bg: "#E0F2FE", label: "Waiting for Employee" },
  scheduled: { bg: "#F3E8FF", label: "Scheduled" },
  completed: { bg: "#DCFCE7", label: "Completed" },
};

export const StatusBadge = ({ status, testid }) => {
  const s = STATUS_STYLE[status] || STATUS_STYLE.pending;
  return (
    <span data-testid={testid} className="inline-flex items-center rounded-full px-3 py-1 text-xs font-bold border-2 border-black" style={{ backgroundColor: s.bg }}>
      {s.label}
    </span>
  );
};
